import React from 'react';

const SvgChecked: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M9.741 17C9.50832 17 9.295 16.9232 9.12049 16.7502L5.26178 12.927C4.91275 12.5812 4.91275 12.0432 5.26178
      11.6974C5.61081 11.3516 6.15373 11.3516 6.50276 11.6974L9.76039 14.9059L17.4972 7.25936C17.8463 6.91354 18.3892
      6.91354 18.7382 7.25936C19.0873 7.60518 19.0873 8.14313 18.7382 8.48896L10.3809 16.7502C10.187 16.9232 9.97369
      17 9.741 17Z"
      fill="#FF6661"
    />
  </svg>
);

export default SvgChecked;
